
import React, { useEffect, useState, useContext, useCallback } from "react";
import axios from "axios";
import cn from "classnames";
import Header from "../components/Header";
import Navigation from "../components/Navigation";
import StatusBar from "../components/StatusBox";
import styles from "./Master.module.scss";
import AppContext from "../components/ApplicationContext";
import authService from "../services/auth.service";
import { getRequestInAssets } from "../../src/services/axiosAssetsBaseClient";
import { createGlobalStyle } from "styled-components";
import LocalStorageService from "services/tokenlocalstorage.service";
import tokenlocalstorageService from "services/tokenlocalstorage.service";
import jwtDecode from "jwt-decode";
import { getRequestInService as getRequestEmail } from "services/axiosServiceBaseClient";
import oauth from "../../src/services/axiosBaseAuthClient";
import { getRequest  } from "services/axiosBaseClient";
import notificationService from "services/notification.service";
import { Link } from "react-router-dom/cjs/react-router-dom";

export default function Master(props) {
  const currentYear = new Date().getFullYear();
  const titleCase = (title) => {
    return title
      ? title
        .split(/ /g)
        .map(
          (word) =>
            `${word.substring(0, 1).toUpperCase()}${word.substring(1)}`
        )
        .join(" ")
      : "";
  };
  const [version, setVersion] = useState("");
  const myContext = useContext(AppContext);
  const [image, setImage] = useState([]);
  const [userName, setUserName] = useState("");



  // const [headerFilter, setHeaderFilter] = useState(true);


  const siteUrlId = props.UrlSiteData;
  const { height, width } = useWindowDimensions();

  const getUserDetail = useCallback(async () => {

    const token = tokenlocalstorageService.getLocalAccessToken();
    var decode = jwtDecode(token);
    const userRole = LocalStorageService.get("user-role");
    let currentRole = "";
    let email = "";
    email = decode.email;
    userRole.toLocaleLowerCase() === "admin"
      ? (currentRole = "admin")
      : (currentRole = "operator");
    await getRequestEmail(
      "bss/svc/" + currentRole +"/info"
    ).then((res) => {
      if (res && res?.data) {
        setUserName(res?.data?.username);
      }
    });
  }, []);

  function containsWhitespace(str) {
    return /\s/.test(str);
  }

  useEffect(() => {
    // getSiteStatus();
    getUserDetail();
    getBssVersion();
    oauth.refreshToken(true);
    const interval = setInterval(() => {
      oauth.refreshToken(false);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const getBssVersion = async (id) => {
    await getRequest("bss/version")
      .then((res) => {
        if (res.data != null) {
          setVersion(res.data)
        }
      })
      .catch((error) => {
        notificationService.showNonBlacklistedError(
          error?.config?.url,
          error?.response?.data?.message
        );
      });
  };




  return (
    <div className={cn("Master", styles.block, styles.block_layout)}>
      {/* <div className={cn(styles.block10, styles.block10_layout)} /> */}
      <Header
        className={cn(styles.block10, styles.block10_layout)}
        filter_ic={
          require("assets/185cc62ad0fb618d8158311bfa949257.png").default
        }
        profile_ic={
          require("assets/eb179045f0ceefe73300cb7edb2c978a.png").default
        }
        small_text_body1={"90"}
        username={!containsWhitespace(userName) ? userName : userName?.substring(0, userName?.indexOf(' '))}
        navOpen={myContext.navOpen}
        setNavOpen={myContext.setNavOpens}
        image={image}
        headerFilter={props.headerFilter}
        setHeaderFilter={props.setHeaderFilter}
      />

      <div className={cn(styles.flex, styles.flex_layout)}>
        <div
          className={cn(styles.flex_item)}
          style={
            !myContext.navOpen
              ? { width: "8%", maxWidth: "90px", "--fwidth": "90px" }
              : width < 1024
                ? width < 850
                  ? { width: "9%", minWidth: "155px", "--fwidth": "155px" }
                  : { width: "12%", minWidth: "180px", "--fwidth": "180px" }
                : { width: "16%", minWidth: "240px", "--fwidth": "240px" }
          }
        >
          {/* <div className={cn(styles.group, styles.group_layout)} /> */}
          <Navigation navOpen={myContext.navOpen} setImage={setImage} enterpriseUser={!containsWhitespace(userName) ? userName : userName?.substring(0, userName?.indexOf(' '))} />
        </div>
        <div className={cn(styles.flex_spacer)} />
        <div
          className={!myContext.navOpen ? cn(styles.flex_width, styles.flex_item1) : cn(styles.flex_width1, styles.flex_item1)}
        >
          <div
            className={cn(styles.page_group, styles.page_group_layout)}
            style={!myContext.navOpen ? { width: "100%" } : { width: "100%" }}
          >
            {/* startCOmponent here */}
            {props.screen({
              ...props.opts, headerFilter: props.headerFilter, setHeaderFilter: props.setHeaderFilter
            })}

            {/* end component heer */}
          </div>
        </div>

        {props.showStatus ? (
          <>
            <div className={cn(styles.flex_spacer1)} />
            <div className={cn(styles.flex_item2)}>
              <div
                style={{
                  "--src": `url(${require("assets/88cc674356c44786b3bb77c47aeee641.png")
                      .default
                    })`,
                }}
                className={cn(styles.image2, styles.image2_layout)}
              />
            </div>
            <div className={cn(styles.flex_spacer2)} />
            <div
              className={cn(styles.flex_item3)}
              onAnimationEnd
              style={!myContext.navOpen ? { width: "10%" } : { width: "10%" }}
            >
              <div className={cn(styles.block11, styles.block11_layout)}>
                {/* <div className={cn(styles.box6, styles.box6_layout)} > */}
                <StatusBar
                  Url={props.dashboardName}
                  dUrl={props.siteName}
                  siteUrl={props.sitesName}
                  swappingId={props.swappingId}
                  batteryUrl={props.batteryListName}
                  batteryNameUrl={props.batteryName}
                  swappingUrl={props.swappingName}
                  swapUrl={props.swapping}
                  batteryId={props.batteryId}
                  siteUrlId={siteUrlId}
                  siteNameURL={props.siteNameURL}
                  enterpriseNameURL={props.enterpriseNameURL}
                  ServiceRequesturl={props.ServiceRequesturl}
                  ServiceListingurl={props.ServiceListingurl}
                  batterySerialIId={props.batterySerial}
                  activeSitetabId={Number(props.opts.match.params.view)}
                />
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>

      {version && <div className={cn(styles.footer)}>
        <div className={cn(styles.footer_block)}>
        <div className={cn(styles.footer_inner_block1)}>
        <img
          src={require("assets/ic_jio_dot.svg").default}
        ></img>
        <p>Copyright © {currentYear} Reliance Jio Infocomm Ltd. All rights reserved.</p>
        </div>
        <div className={cn(styles.footer_inner_block2)}>
         
          <p>Version: {version}</p>
          <div className={cn(styles.footer_divider)}>|</div>
          <Link to="/privacy_policy">
          <p>Privacy</p>
          </Link>
          <div className={cn(styles.footer_divider)}>|</div>
          <Link to="/terms_conditions">
          <p>Terms & Conditions</p>
          </Link>
        </div>
        </div>
        {/* {version} */}
      </div>}

    </div>
  );
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
